module.exports = __webpack_public_path__ + "img/VL_09_02.534bf478.png";